// Event frontmatter `category` enum (§5.4) -> display label for the
// SEOHead title pattern "{title} – {category} | Tales&Legends" (§10.3).
const EVENT_CATEGORY_LABELS = {
  "larp-con": { de: "LARP-Con", en: "LARP Con" },
  workshop: { de: "Workshop", en: "Workshop" },
  "jugend-event": { de: "Jugend-Event", en: "Youth Event" },
  fortbildung: { de: "Fortbildung", en: "Training" },
  taverne: { de: "Taverne", en: "Tavern" },
  // For events we attend with our own camp but don't organize ourselves —
  // e.g. Wayfarer at Conquest of Mythodea — distinct from "larp-con", which
  // implies we're running the con.
  "zu-gast": { de: "Zu Gast", en: "Guest Appearance" },
};

export function eventCategoryLabel(category, lang) {
  return EVENT_CATEGORY_LABELS[category]?.[lang] ?? category;
}
